'use client';
import styled from 'styled-components';

export const RichTextStyled = styled.div`
  padding: ${props =>
    props.theme.spacing(props.$verticalPadding, props.$horizontalPadding)};
  ${props => props.$typography && props.theme.typography[props.$typography]};
`;
